export default __webpack_public_path__ + "static/media/day_partial_cloud.f67f9128.svg";